package com.macrofocus.eflux.network

import com.macrofocus.eflux.network.physical.PhysicalNetwork
import org.molap.datetime.DateTimeTz

fun buildSustationNetwork(time: DateTimeTz, physicalNetwork: PhysicalNetwork, block: SubstationNetworkBuilder.() -> Unit): SubstationNetwork =
    SubstationNetworkBuilder(
        time,
        physicalNetwork
    ).apply(block).build()
